import type { CurriculumAccent } from '@/pages/learner/ui-model/types'

export const curriculumAccentBgClass: Record<CurriculumAccent, string> = {
  'core-a': 'bg-lc-curriculum-core-a',
  'core-b': 'bg-lc-curriculum-core-b',
  'core-c': 'bg-lc-curriculum-core-c',
  'core-d': 'bg-lc-curriculum-core-d',
  'core-e': 'bg-lc-curriculum-core-e',
  advanced: 'bg-lc-curriculum-advanced',
  elite: 'bg-lc-curriculum-elite',
  key: 'bg-lc-key-500',
}
